import React from 'react';
import { connect } from 'react-redux';
import './FabcoLoadingFull.scss';
import { Spinner } from 'react-bootstrap';

const FabcoLoadingFull = (props) => {
  const { isLoading, loadingText } = props.fullLoading;

  if (isLoading) {
    return (
        <div className='fabco-loading-full-container'>
            <div className='d-flex align-items-center bg-white rounded p-2'>
                <Spinner animation='border' size='sm' variant='primary'/>
                <span className='ms-1'>{loadingText}</span>
            </div>
        </div>
      );
  } else {
    return <></>
  }
  
};

const mapStateToProps = (state) => {
  return {
    fullLoading: state.loadingReducer.fullLoading
  };
};

export default connect(mapStateToProps)(FabcoLoadingFull);
